import { TypeKeys } from './actionsUtils.js';
import type { Action } from 'redux';

export interface ApplyAnalyticsEventAction extends Action {
  eventData: object;
  type: TypeKeys.APPLY_ANALYTICS_EVENT;
}

export const applyAnalyticsEvent = (eventData: object): ApplyAnalyticsEventAction => ({
  eventData,
  type: TypeKeys.APPLY_ANALYTICS_EVENT,
});

export interface ApplyWizardEventAction extends Action {
  step: number;
  name: string;
  type: TypeKeys.APPLY_WIZARD_EVENT;
}

export const applyWizardEvent = (step: number, name: string): ApplyWizardEventAction => ({
  step,
  name,
  type: TypeKeys.APPLY_WIZARD_EVENT,
});

export interface HardRedirectAction {
  type: TypeKeys.HARD_REDIRECT;
  path: string;
}

export const hardRedirect = (path: string): HardRedirectAction => ({
  path,
  type: TypeKeys.HARD_REDIRECT,
});

export interface ResetErrorsAction {
  type: TypeKeys.RESET_ERRORS;
}

export const resetErrors = (): ResetErrorsAction => ({
  type: TypeKeys.RESET_ERRORS,
});

export type GeneralActionTypes = ApplyAnalyticsEventAction | ApplyWizardEventAction | ResetErrorsAction;
